
/**
 * @overview 推荐编辑
 * @author jzhu
 * @date 2020-9-24
 */

import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, modelUtils } = framework_tool
let { WizCard, WizForm, WizSpin, WizRow, WizCol, WizButton } = component_tool
let { Session } = utils_tool

const getParamRecord = (history) => {
    let record = null
    if (history.location && history.location.pathname === '/version/management/versionUpd') {
        if (history.location.record) {
            record = history.location.record
            Session.set('versionUpd', record)
        } else {
            record = Session.get('versionUpd') || {}
        }
    }
    return record
}

class VersionDetail extends WizContainer {

    componentName = 'VersionDetail'

    constructor(props) {
        super(props)
        let { history } = props
        let record = getParamRecord(history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        let { record } = this.state
        if (record && record.id) {
            this.doAction({
                path: 'version/findVersionById',
                payload: {
                    key: 'versionInfo',
                    apiParams: { id: record.id }
                }
            })
        }
    }

    _onSubmit = (values) => {
        let { id, releaseTime } = values
        let time = releaseTime.valueOf()
        let action = id ? 'update' : 'create'
        this.doAction({
            path: 'version/' + action,
            payload: {
                key: 'version_save',
                apiParams: { ...values, releaseTime: time }
            }
        })
    }

    propsAndStateOnChange = {
        versionInfo: this._versionInfoOnChange.bind(this),
        save: this._saveOnChange.bind(this)
    }

    _versionInfoOnChange(nextProps, nextState) {
        if (nextProps.versionInfo.code === 1) {
            nextState.record = nextProps.versionInfo.data
        }
        return true
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('保存成功')
            this.jumpPage('push', '/version/management')
        } else {
            wizNotice.error((nextProps.save && nextProps.save.msg) || '操作失败,请稍后尝试')
        }
        return true
    }

    /**
     * 重置
     */
    _onReset = () => {
        this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns col-item'>
                <WizCol span={24}>
                    <WizButton title='保存' icon='check' type='primary' htmlType='submit'>保存</WizButton>
                    <WizButton title='重置' icon='reload' onClick={e => this._onReset()}>重置</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    _render() {
        let { record } = this.state
        let title = record && record.id ? '编辑版本' : '新增版本'
        let formProps = {
            ref: 'form',
            columns: this._columns(),
            record: record,
            onSubmit: this._onSubmit,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }
        return (
            <WizCard>
                <WizSpin tip={'加载中'} spinning={this.props.versionLoading}>
                    <WizForm className={'form-inline'} {...formProps} />
                </WizSpin>
            </WizCard>
        )
    }

    _columns = () => {
        let reg = new RegExp('^[0-9]{1,}[.][0-9]{1,}[.][0-9]{1,}$')
        return [
            {
                name: 'id',
                formItem: {
                    type: 'hidden'
                }
            },
            {
                title: '版本号',
                name: 'version',
                dataIndex: 'version',
                formItem: {
                    maxLength: 20,
                    style: { maxWidth: 300 },
                    rules: [
                        { required: true, message: '请输入版本号' },
                        { pattern: reg, message: '版本号错误，版本号规则为 N.N.N，N为不小于0的整数'}
                    ]
                }
            },
            {
                title: '版本类型',
                name: 'type',
                dataIndex: 'type',
                dict: [
                    { code: 0, codeName: '移动课堂Ios' },
                    { code: 1, codeName: '移动课堂Android' },
                    { code: 2, codeName: '培训助手' }
                ],
                formItem: {
                    type: 'select',
                    style: { maxWidth: 300 },
                    rules: [{ required: true, message: '请选择关联类型' }]
                }
            },
            {
                title: '更新内容',
                name: 'content',
                dataIndex: 'content',
                formItem: {
                    type: 'textarea',
                    maxLength: 500
                }
            },
            {
                title: '更新类型',
                name: 'updateType',
                dataIndex: 'updateType',
                dict: [
                    { code: 0, codeName: '普通更新' },
                    { code: 1, codeName: '强制更新' }
                ],
                formItem: {
                    type: 'select',
                    style: { maxWidth: 300 },
                    rules: [{ required: true, message: '请选择关联类型' }]
                }
            },
            {
                title: '更新地址',
                name: 'updateUrl',
                dataIndex: 'updateUrl',
                formItem: {
                    maxLength: 200
                }
            },
            {
                title: '发布时间',
                name: 'releaseTime',
                dataIndex: 'releaseTime',
                formItem: {
                    type: 'datetime',
                    style: { maxWidth: 300 },
                    rules: [{ required: true, message: '请选择发布时间' }]
                }
            }
        ]
    }
}

const mapStateToProps = (state, ownProps) => {
    const { version } = state
    const save = modelUtils.getModelEntity(version, 'version_save')
    const versionInfo = modelUtils.getModelEntity(version, 'versionInfo')
    const load = modelUtils.getLoadingState(state, 'version')
    return {
        save,
        versionInfo,
        ...load
    }
}

export default connect(mapStateToProps)(VersionDetail)
